export default __webpack_public_path__ + "media/zurb/img/about/bryan/twitter-icon-209afa93b0cedae60f4a48d5340675c7.svg";